export default __webpack_public_path__ + "static/media/online-consulting.bbc2f930.svg";